import styled from "styled-components";
import { MenuButton } from "./Buttons";

export const Menu = styled.ul<{ $menuPosition?: string; $menuWidth?: string }>`
  display: inline-block;
  background-color: var(--ons-color-ocean-blue);
  padding: 18px;
  list-style: none;
  ${(props) =>
    props.$menuWidth === "wide" ? "width: 306px;" : "width: 200px;"}
  border-radius: 3px;
  border: 2px solid var(--ons-color-night-blue);
  position: absolute;
  ${(props) => (props.$menuPosition === "right" ? "right: 0;" : "left: 0;")}
  z-index: 20;
`;

export const Icon = styled.span`
  fill: var(--ons-color-white);
  ${MenuButton}:focus & {
    svg {
      fill: var(--ons-color-black);
    }
  }
  margin-right: 20px;
  font-size: 24px;
  line-height: 1;
  display: inline-block;
  text-align: center;
`;

export const MenuButtonLabel = styled.span<{ disabled?: boolean }>`
  text-align: left;
  ${(props) => props.disabled && "opacity: 50%; color: var(--ons-color-white);"}
`;
